import React from 'react'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../styles'
import { ClassValue } from 'classnames/types'
import { ContractsModel } from '../../../types/contracts/contractsModel'
import { FormattedMessage } from 'react-intl'
import { useMediaQuery } from 'react-responsive'
import ContractDetails from '../../dashboard/dashboard_contracts/ContractDetails'
import { propertyType } from '../../../enums/contractsEnum'
import SvgApartment from '../../../icons/Apartment'
import SvgGarage from '../../../icons/Garage'

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			summaryContainerLargeScreenStyle: {
				marginTop: '30px',
				padding: '48px 72px 48px 56px',

				'& > div': {
					padding: 0
				},
				'& img': {
					width: '100px',
					height: '100px'
				}
			},
			summaryContainerSmallScreenStyle: {
				marginTop: '15px',
				padding: '27px 15px 24px 24px',

				'& .row div:first-child': {
					marginBottom: '10px'
				},
				'& img': {
					marginBottom: '20px',
					width: '56px',
					height: '56px'
				}
			}
		}
	)
)

interface AcceptingProps {
	contract: ContractsModel
}

type SummaryProps = AcceptingProps

const Summary: React.FC<SummaryProps> = (
	{
		contract
	}
) => {
	const classes = useStyle()
	const type: string = `dashboard.contracts.type.${contract.type}`
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const summaryContainerClass: ClassValue = classNames(
		classes.backgroundBlue,
		classes.flex,
		classes.flexBetween,
		classes.colorWhite,
		{
			[classes.summaryContainerLargeScreenStyle]: isLargeScreen,
			[classes.alignCenter]: isLargeScreen,
			[classes.summaryContainerSmallScreenStyle]: !isLargeScreen,
			[classes.flexColumnReverse]: !isLargeScreen
		}
	)

	const typeClass: ClassValue = classNames(
		'col-xs-12 col-md-6',
		{
			[classes.text10]: isLargeScreen,
			[classes.title4]: !isLargeScreen
		}
	)

	return (
		<div className={summaryContainerClass}>
			<div className="col-xs-12 col-md-9">
				<div className="row">
					<div className={typeClass}>
						<FormattedMessage
							id={type}
							defaultMessage="Appartement"
							description="Dashboard contract type text"
						/>
					</div>

					<div className="col-xs-12 col-md-6">
						<ContractDetails
							contract={contract}
							color="colorWhite"
							text={isLargeScreen ? 'text1' : 'text3_opacity'}
						/>
					</div>
				</div>
			</div>
			{isLargeScreen &&
			<div className="col-xs-12 col-md-3 end-md">
				{
					contract.type === propertyType.apartment ? (
						<SvgApartment color="#FFF" height={96} width={96} />
					) : (
						<SvgGarage color="#FFF" height={96} width={96} />
					)
				}
			</div>
			}
		</div>
	)
}

export default Summary
